<div class="d-flex flex-column" (click)="onClick($event)">
    <span class="mx-2  text"  [ngClass]="{'cursorPointer': isCursor ,'d-block h-100':params?.widthFull}">{{name}}</span>
    <span class="mx-2 text2" [ngClass]="{'cursorPointer': isCursor ,'d-block h-100':params?.widthFull}">{{value}}</span>

</div>
<span *ngIf="worklogReport==true" class="mx-2 d-block h-100">{{params?.data?.date}}</span>

